import request from "@/utils/request.js";

// 应用列表
export function enterpriseleveloperlist(data) {
  return request({
    url: "/api/application/page",
    method: "get",
    params: data
  });
}

// 应用列表
export function deleteApp(id) {
  return request({
    url: `/api/application/delete/${id}`,
    method: "delete",
  });
}

// 新增应用
export function editApp(data) {
  return request({
    contentType: false,
    url: "/api/application/edit",
    method: "post",
    data
  });
}

// 新增应用
export function instapplication(data) {
  return request({
    contentType: false,
    url: "/infor/instapplication",
    method: "post",
    data,
    headers: {
      "content-type": "multipart/form-data"
    }
  });
}
// 编辑应用
export function updateApplication(data) {
  return request({
    contentType: false,
    url: "/infor/instdeveloper",
    method: "post",
    data,
    headers: {
      "content-type": "multipart/form-data"
    }
  });
}
// 删除应用 /api/application/delete/{id}

export function deleteAPPbyid(id) {
  return request({
    url: `/api/application/delete/${id}`,
    method: "DELETE"
  });
}

// 新增应用
export function instimg(data) {
  return request({
    url: "/infor/instimg",
    method: "post",
    data,
    headers: {
      "content-type": "multipart/form-data"
    }
  });
}
